import SubcategoryPage from '@/components/template/SubcategoryPage';

const MarbleTray = () => {
  const products = [
    {
      title: "Marble Tray Round",
      imageSrc: "https://images.unsplash.com/photo-1622398925373-3f91b1ff780f?auto=format&fit=crop&q=80",
      url: "/proizvodi/marble-tray-round"
    },
    {
      title: "Marble Tray Square",
      imageSrc: "https://images.unsplash.com/photo-1581912492723-688317ba2762?auto=format&fit=crop&q=80",
      url: "/proizvodi/marble-tray-square"
    },
    {
      title: "Marble Tray Rectangle",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/proizvodi/marble-tray-rectangle"
    }
  ];

  return (
    <SubcategoryPage
      title="Marble Tray"
      description="Elegantni marmornati pladnji, ki združujejo naravno lepoto materiala in funkcionalno oblikovanje."
      heroImage="https://images.unsplash.com/photo-1622398925373-3f91b1ff780f?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default MarbleTray;